import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40 53.731c-7.816 0-14.154-6.145-14.154-13.731 0-7.583 6.338-13.731 14.154-13.731S54.154 32.417 54.154 40c0 7.586-6.338 13.731-14.154 13.731zm30.562-9.85c.167-1.283.289-2.56.289-3.881 0-1.318-.122-2.64-.29-4l8.679-6.522c.78-.598.987-1.68.493-2.556L71.51 13.078c-.493-.88-1.602-1.238-2.507-.88l-10.241 4c-2.138-1.558-4.359-2.918-6.948-3.92L50.29 1.68C50.125.72 49.263 0 48.234 0h-16.45c-1.03 0-1.891.72-2.055 1.68l-1.524 10.598c-2.589 1.002-4.81 2.362-6.948 3.92l-10.24-4c-.906-.358-2.014 0-2.508.88L.285 26.922c-.533.876-.29 1.958.493 2.556L9.453 36c-.164 1.36-.286 2.682-.286 4 0 1.322.122 2.598.286 3.882l-8.675 6.64a1.936 1.936 0 0 0-.493 2.56l8.224 13.84c.494.876 1.602 1.2 2.507.876l10.241-4.038c2.139 1.6 4.36 2.96 6.948 3.962L29.73 78.32c.164.96 1.026 1.68 2.056 1.68h16.449c1.03 0 1.891-.72 2.056-1.68l1.523-10.598c2.589-1.04 4.81-2.362 6.948-3.962l10.241 4.038c.905.324 2.014 0 2.507-.876l8.224-13.84c.494-.88.287-1.962-.493-2.56l-8.678-6.64z"
  }));
});